<div *ngIf="referralCode; else loading" class="wrapper" fxLayout="column" fxLayoutAlign=" center">
  <div class="title">Refer and Earn</div>
  <div fxLayout="column" fxLayoutAlign=" center" fxLayoutGap="40px">
    <div class="modal-text">
      <div>Earn ₦500 whenever someone signs up on PaveHQ using your referral code.</div>
      <a target="_blank" [routerLink]="['/','information','terms-and-conditions']">Read the terms and conditions.</a>
    </div>
    <div fxLayout="column" fxLayoutGap="8px">
      <div class="modal-small-text">Your personalized referral code is</div>
      <button class="pave-button" mat-raised-button (click)="copyCode()">
        <span>{{this.referralCode}}</span>
        <mat-icon style="margin-left: 16px">file_copy</mat-icon>
      </button>
    </div>
    <div fxLayout="column" fxLayoutGap="8px">
      <div class="modal-small-text">Or use a referral link</div>
      <button *ngIf="canShare" class="pave-button" mat-raised-button (click)="shareLink()">Share referral link</button>
      <button *ngIf="!canShare" class="pave-button" mat-raised-button (click)="copyLink()">Copy referral link</button>
    </div>
  </div>
  <mat-icon class="close-button" mat-icon-button (click)="dialogRef.close()">
    close
  </mat-icon>
</div>

<ng-template #loading>
  <mat-progress-bar color="primary" mode="indeterminate" diameter="8" strokeWidth="2"></mat-progress-bar>
</ng-template>